<div id="todo" class="page-layout carded left-sidebar inner-scroll">


    <!-- CENTER -->
    <div class="center">

        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <ngx-datatable
                        #table
                        class="material"
                        [rows]="rows"
                        [loadingIndicator]="loadingIndicator"
                        [columnMode]="'force'"
                        [headerHeight]="48"
                        [footerHeight]="56"
                        [rowHeight]="'auto'"
                        [scrollbarH]="true"
                        [reorderable]="reorderable"
                        [selectionType]="'checkbox'"
                        [externalPaging]="true"
                        [count]="page.totalElements"
                        [offset]="page.pageNumber"
                        [limit]="page.size"
                        (page)="setPage($event)"
                        (sort)="sortResults($event)"
                    >

                        <ngx-datatable-column name="{{'Description'|translate}}" prop="createdAt">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{ row.description }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Severity'|translate}}" prop="createdAt">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{ row.severity }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Created at'|translate}}" prop="createdAt">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{ row.createdAt|date: 'dd.MM.y HH:mm':'UTC+2': locale }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Created by'|translate}}" prop="createdAt">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{ row.createdBy.firstName }} {{ row.createdBy.lastName }} ({{ row.createdBy.email }})
                            </ng-template>
                        </ngx-datatable-column>




                        <ngx-datatable-column name="{{'Actions'|translate}}" sortable="false" prop="id">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <a (click)="openLogDetails(row)" style="cursor: pointer;">{{'Details'|translate}}</a>

                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
